module.exports = __webpack_public_path__ + "img/header.6b1f81a2.png";